var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_314339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 26.6666H23.3359C24.2526 26.6666 25.0026 25.9166 25.0026 25V16.6666H27.6526C29.1359 16.6666 29.8859 14.8666 28.8359 13.8166L21.1859 6.16664C20.5359 5.51664 19.4859 5.51664 18.8359 6.16664L11.1859 13.8166C10.1359 14.8666 10.8693 16.6666 12.3526 16.6666H15.0026V25C15.0026 25.9166 15.7526 26.6666 16.6693 26.6666ZM10.0026 30H30.0026C30.9193 30 31.6693 30.75 31.6693 31.6666C31.6693 32.5833 30.9193 33.3333 30.0026 33.3333H10.0026C9.08594 33.3333 8.33594 32.5833 8.33594 31.6666C8.33594 30.75 9.08594 30 10.0026 30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_314339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.937650bebeb46de07469ad878616abf8.svg";
export { ForwardRef as ReactComponent };